import { Type, type Static } from '@sinclair/typebox';
import { PublicOrganization } from '../organization/organization.schema';
import type { PublicUser } from '../user/user.schema';

export const SocialAuthStartResponseSchema = Type.Object(
  { url: Type.String({ format: 'uri', description: 'Provider authorization URL to open in the browser.' }) },
  { description: 'Authorization URL for the requested social authentication attempt.' },
);
export type SocialAuthStartResponse = Static<typeof SocialAuthStartResponseSchema>;

export type DashboardAuthUser = PublicUser & {
  organizations: Pick<PublicOrganization, 'id' | 'name'>[];
};

export type UserAuthenticationResponse = { status: 'success' } & DashboardAuthUser;

export type UserAuthenticationMfaResponse = { status: 'mfa'; token: string };

export type UserAuthenticationMfaRequiredResponse = { status: 'mfa_required'; org_name: string };

/** Valid v1 credentials; the user must sign in separately on the v1 dashboard. */
export type UserAuthenticationV1Response = { status: 'v1_account' };

export type AuthenticationResponse =
  | UserAuthenticationResponse
  | UserAuthenticationMfaResponse
  | UserAuthenticationMfaRequiredResponse
  | UserAuthenticationV1Response;
